import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Component } from "react";
import { Button } from "react-bootstrap";
import { ACTION_TYPES, MAX_LENGTH } from "../../../../constants/external-constants";
import { addPlanDetailActions } from "../../../../store/external/inventory/details-view/add-plan-details.reducer";
import { REQUEST_TYPES_ID, TRANSLATIONS } from '../../../../utils/constant.utils';
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import TableWithButton from "../../../common/details-table/table-with-button.component";
import { NotificationModal } from "../../../common/modal/notification-modal.component";
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../../utils/constant.utils";
import CustomSearchableDropdownWrapper from "../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
class AddPlanDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDropdown: false,
            showTable: false,
            enableAddBtn: true,
            inventorycircuit_plans_Id: null,
            showNotif: false,
            showModal: false,
            notifTitle: '',
            isUpdate: false,
            isNewPlan: false,
            checkedItems: [],
            hasSelectedNewPlan: false,
            originalPlanComponents: [],
            isOrigComponent: false,
            updatedCheckboxState: {},
            isLoadingComponents: true,
        }
        this._isMounted = false; 
    }

    loadPlanDetails(planId, useOriginalComponent) {
        this.setState({ isLoadingComponents: true });

        const { UniquePlanIdentifier } = this.props.inventoryCicuitPlanDetailsForm;
        let trimmedPlanId;
        let isOriginalComponent = (useOriginalComponent && this.props.isOriginalComponent) ? true : useOriginalComponent;

        if (typeof planId === 'string' && (planId.includes('_Orderable') || planId.includes('_InUse'))) {
            isOriginalComponent = planId.includes('_InUse') ? true : isOriginalComponent;
            trimmedPlanId = planId.replace(/(_Orderable|_InUse)$/, '');
        } else {
            isOriginalComponent = UniquePlanIdentifier !== undefined && UniquePlanIdentifier.includes('_Orderable') ? false : this.props.isOriginalComponent;
            trimmedPlanId = planId;
        }

        const updatedOriginalPlanComponents =
            this.props.inventoryCircuitPlanDetails?.checkedItems.map((checkedItem) => ({
                ...checkedItem,
                UniquePlanIdentifier:
                    this.props.inventoryCicuitPlanDetailsForm?.UniquePlanIdentifier,
            })) || [];

        if (this._isMounted) {
            this.setState({
                isUpdate: this.updatePlan(trimmedPlanId),
                isOrigComponent: isOriginalComponent,
                inventorycircuit_plans_Id: trimmedPlanId,
                checkedItems: updatedOriginalPlanComponents && updatedOriginalPlanComponents.length > 0 ? updatedOriginalPlanComponents : [],
            });
        }

        // Fetch components and stop loading once data is received
        this.props
            .getInventoryCircuitPlanComponents(trimmedPlanId, this.props.isInventoryCircuit ? isOriginalComponent : false)
            .finally(() => {
                if (this._isMounted) {
                    this.setState({ isLoadingComponents: false });
                }
            });
    }

    ShowTable() {
        this.props.showDetails(true)
    }

    clearField(){
        //please change the actual state of your component
        this.setState({ filterSelected: "", showTable:false })
        this.searchableChange(0)
    }

    componentDidMount() {
        const { getInventoryCircuitPlanDetails, getInventoryCircuitPlanComponents, circuitId, planId,
            getInventoryPlanTypesByVendorByCircuitTypeAsync, circuitTypeId, vendorId, isCircuitOrder, checkedItems } = this.props;
        const { hasSelectedNewPlan } = this.state;
        this._isMounted = true;
        const updatedCheckboxState = (checkedItems || []).reduce((acc, item) => {
            acc[item.PlanComponentId] = true;
            return acc;
        }, {});
        this.setState({
            checkedItems: checkedItems || [],
            isOrigComponent: this.props.isOriginalComponent || false,
            updatedCheckboxState: updatedCheckboxState || {}
        });
        if (checkedItems && checkedItems.length > 0) {
            this.setState({ checkedItems });
        }
        getInventoryPlanTypesByVendorByCircuitTypeAsync(vendorId, circuitTypeId, 1,'');
        if (circuitId && planId && !hasSelectedNewPlan) {
            getInventoryCircuitPlanComponents(planId, true);
        }
        else {
            getInventoryCircuitPlanComponents(planId, false);
        }
        if (!isCircuitOrder) {
            getInventoryCircuitPlanDetails(circuitId);
        }
    }

    componentWillUnmount() {
        const { resetPlanDetails } = this.props;
        this.clearField();
        resetPlanDetails();
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isTogglePlan !== this.props.isTogglePlan) {
            // Close the dropdown if isTogglePlan changes
            this.setState({ activeDropdown: false });
        }
        if (prevProps.isOriginalComponent !== this.props.isOriginalComponent) {
            this.setState({ hasSelectedNewPlan: this.props.isOriginalComponent ? false : true });
        }
        if (prevProps.inventoryCircuitPlanDetails.checkedItems !== this.props.inventoryCircuitPlanDetails.checkedItems) {
            this.setState({
                checkedItems: this.props.inventoryCircuitPlanDetails.checkedItems
            });
        }
        if (!this.props.inventoryCicuitPlanDetailsForm.PlanId && this.props.inventoryCircuitPlanDetails.checkedItems.length > 0 ) {
            this.props.getInventoryCircuitPlanComponents(0)
        }
    }
    cancelBtn() {
        this.setState({ enableAddBtn: false })
        const { inventoryCicuitPlanDetailsForm } = this.props;
        const { isNewPlan, originalPlanComponents } = this.state;
        this.loadPlanDetails(originalPlanComponents[0]?.UniquePlanIdentifier, true);
        this.setState({ isLoadingComponents: true });
        if (!inventoryCicuitPlanDetailsForm.PlanId || isNewPlan) {
            this.clearField()
        }

        this.isActiveDropDownState();
        if(this.props.titleBtn===ACTION_TYPES.Update) {
            this.props.toggleDropdown()
            this.props.showDetails(true)
            this.props.enableUpdate(false)

        }
    }

    onChangeInventoryCircuitPlanSelect = (indicator, item) => {
        const { getInventoryCircuitPlanComponents, inventoryCircuitPlanDetails } = this.props;

        if (item !== inventoryCircuitPlanDetails.PlanId) {
            getInventoryCircuitPlanComponents(item);
        }

        this.setState({
            enableUpdate: true,

        });
    }
    transformOptions = (options) => {
        return options?.map((plan) => ({
            FilterId: plan.UniquePlanIdentifier, // Use UniquePlanIdentifier
            FilterName: plan.PlanNameOrderable,
            FilterValue: plan.PlanNameOrderable
        }));
    };
    searchableChange(event, model) {
        const planIdentifier = event; // Capture the selected UniquePlanIdentifier
        this.loadPlanDetails(planIdentifier, false); // Pass the identifier to loadPlanDetails
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    onRowClickPlanDetails = (index) => {
        const { planDetails } = this.props.inventoryCircuitPlanDetails;
        const { hasSelectedNewPlan, originalPlanComponents } = this.state;

        const planId = planDetails.datatable[0]?.dataItem[0]?.PlanId;

        if (!planId) return;

        if (hasSelectedNewPlan) {
            this.loadPlanDetails(planId, false);
        } else {
            this.loadPlanDetails(planId, true);

            if (originalPlanComponents.length === 0) {
                const updatedOriginalPlanComponents = this.props.inventoryCircuitPlanDetails?.checkedItems.map(checkedItem => ({
                    ...checkedItem,
                    UniquePlanIdentifier: this.props.inventoryCicuitPlanDetailsForm?.UniquePlanIdentifier
                })) || [];
                this.setState({
                    originalPlanComponents: updatedOriginalPlanComponents
                });
            }
        }
        this.isActiveDropDownState();

        this.setState({
            isUpdate: true
        });

    };

    isActiveDropDownState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    toggleActiveState = () => {
        this.setState({ isUpdate: false });
        if (this.hasExistingPlan() || !this.props.requestTypeId === REQUEST_TYPES_ID.changeUser) {
            this.setState({ activeDropdown: false });
        }
        else{
            this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown, isNewPlan: true }));
        }
    }

    deletePlanDetails = (index) => {
        this.props.deletePlanDetails();
        this.props.handleChangesStatus('planDetailsChange', true, "0.00", true);
        this.clearField();
        this.setState({ activeDropdown: false });
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }
    handleOpenNotif = () => {
        this.setState({
            showNotif: true,
            notifTitle: 'Delete'
        });
    }

    hasExistingPlan = () => {
        const { planDetails } = this.props.inventoryCircuitPlanDetails;
        let planExist = false;
        if (planDetails.datatable.length > 0) {
            planExist = planDetails.datatable[0].dataItem.length > 0;
        }

        return planExist;
    }

    updatePlan = (planId) => {
        const { planDetails } = this.props.inventoryCircuitPlanDetails;
        let update = false;

        if (planDetails.datatable.length > 0) {
            const dataItem = planDetails.datatable[0].dataItem;
            if (dataItem.length > 0) {
                update = dataItem.findIndex(r => Number(r?.PlanId) == planId) != -1;
            }
        }

        return update;
    }

    addPlanDetails = () => {
        this.saveCheckedItems();
        this.props.addPlanDetails();
        this.setState({
            activeDropdown: false
        });
    }

    onClickUpdate = () => {
        this.saveCheckedItems();
        this.setState({
            showModal: true,
            notifTitle: 'Update',
            isUpdate: true
        })
    }

    onClickAdd = () => {
        this.saveCheckedItems();
        this.setState({
            showModal: true,
            notifTitle: 'Add'
        })
    }

    isUpdateBtnDisable = (state, form, circuitPlans) => {
        const { isUpdate, originalPlanComponents, hasSelectedNewPlan, checkedItems, inventorycircuit_plans_Id } = this.state;
        const { PlanId } = form;
        const { isDisable } = this.props;

        const areArraysEqualById = (array1, array2) => {
            if (array1.length !== array2.length) {
                return false;
            }
            const idSet = new Set(array2.map(item => item.PlanComponentId));
            return array1.every(item => idSet.has(item.PlanComponentId));
        };

        // Check for differences between checkedItems and originalPlanComponents
        const checkedItemsWithInUse =
            checkedItems.length > 0 && !areArraysEqualById(checkedItems, originalPlanComponents);

        // Check for differences between checkedItems and datatable PlanComponents
        const datatablePlanComponents =
            this.props.inventoryCircuitPlanDetails?.planDetails?.datatable[0]?.dataItem[0]?.PlanComponents || [];
        const checkedItemsWithoutInUse =
            checkedItems.length > 0 && !areArraysEqualById(datatablePlanComponents, checkedItems);

        // Determine if components have changed
        const componentsHasChange = hasSelectedNewPlan
            ? checkedItemsWithoutInUse
            : (this.props.planId === Number(PlanId) || inventorycircuit_plans_Id === Number(PlanId))
                ? checkedItemsWithInUse
                : true;
     
        // Validate form and determine if update button should be disabled
        if (isUpdate) {
            const isFormValid = !!PlanId;
            const hasChange = circuitPlans?.PlanId !== Number(PlanId);           
            if (!isFormValid) {
                return true;
            }
            if (isDisable) {
                return true;
            }
            return isFormValid && hasChange && !componentsHasChange;
        }

        return false;
    };

    handleCheckItem = (isChecked, itemData) => {
        this.setState(prevState => {
            const updatedCheckboxState = {
                ...prevState.updatedCheckboxState,
                [itemData.PlanComponentId]: isChecked,
            };
            const itemsToAdd = Array.isArray(itemData) ? itemData : [itemData];

            const updatedCheckedItems = itemsToAdd;

            this.props.saveCheckedPlanComponents(updatedCheckedItems);

            return {
                updatedCheckboxState,
                checkedItems: updatedCheckedItems,
            };
        });
    };

    handleSelectAllChange = (isSelectAll, allItems) => {
        const updatedCheckboxState = allItems.reduce((acc, item) => {
            acc[item.PlanComponentId] = isSelectAll;
            return acc;
        }, {});

        const updatedCheckedItems = isSelectAll ? allItems : [];

        this.setState({
            updatedCheckboxState,
            checkedItems: updatedCheckedItems,
        });
        this.props.saveCheckedPlanComponents(updatedCheckedItems);
    };
    // Function to save checked items (if it does not exist)
    saveCheckedItems = () => {
        this.props.saveCheckedPlanComponents(this.state.checkedItems);
    };

    handleConfirmationModal = (buttonType) => {
        const { UniquePlanIdentifier } = this.props.inventoryCicuitPlanDetailsForm;
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.saveCheckedItems();
            this.addPlanDetails();
            const mrc = (typeof UniquePlanIdentifier === 'string' && UniquePlanIdentifier.includes('_InUse'))
            ? this.props.inventoryCircuitPlanDetails.planComponents[0]?.dataItem?.reduce((sum, item) => sum + (item.ComponentCost || 0), 0) 
            : this.state.checkedItems?.reduce((sum, item) => sum + (item.ComponentCost || 0), 0);
            this.props.handleChangesStatus('planDetailsChange', true, mrc, true);
            this.setState(prev => ({
                showModal: !prev.showModal,
                showNotif: false,
                isUpdate: true,
                hasSelectedNewPlan: (typeof UniquePlanIdentifier === 'string' && UniquePlanIdentifier.includes('_InUse')) ? false : true
            }))
        } else {
            this.setState({
                showModal: false,
                isUpdate: false
            });
        }
    }
    displayActionButtons = () =>{
        const { isCircuitOrder, requestTypeId } = this.props;
        return isCircuitOrder && requestTypeId === REQUEST_TYPES_ID.portOut;
    }
    handleCircuitPlansSearch = (query) => {
        const { circuitTypeId, vendorId, } = this.props;
        this.props.getInventoryPlanTypesByVendorByCircuitTypeAsync(vendorId, circuitTypeId, 1, query);
    }

    loadMoreCircuitPlans = (searchString) => {
        const { inventoryCircuitPlanDetails, circuitTypeId, vendorId, } = this.props;
        const {
            circuitPlansPage
        } = inventoryCircuitPlanDetails;
        this.props.getInventoryPlanTypesByVendorByCircuitTypeAsync(vendorId, circuitTypeId, circuitPlansPage + 1, searchString);
    }
    render() {
        const {
            planDetails,
            circuitPlans,
            planComponents,
            isCircuitPlansLoading,
            hasMoreCircuitPlans
        } = this.props.inventoryCircuitPlanDetails;
        const {
            inventoryCicuitPlanDetailsForm,
            hasPendingApproval,
            requestTypeId,
            isCircuitOrder,
            isDisable,
            completed
        } = this.props;

        const { isUpdate, isLoadingComponents } = this.state

        const hasExistingPlan = this.hasExistingPlan();
        const enableButton = (this.state.checkedItems.length > 0 && inventoryCicuitPlanDetailsForm.PlanId)
            ? !this.props.inventoryCircuitPlanDetails?.planDetails?.datatable[0]?.dataItem[0]?.PlanComponents?.every(item => this.state.checkedItems.some(dataItem => dataItem.PlanComponentId === item.PlanComponentId))
            : false;
        const noAddFunction = isCircuitOrder && (parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.subscriptionCancellation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portOut)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.InternationalRoamingAccess)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.terminateSubscriptionWireline)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.CallingAccess));
        const sectionTitle = hasExistingPlan || noAddFunction ? this.toLocaleLanguage('plan_details') : this.toLocaleLanguage('add_plan_details');
        const isRequestRequired = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.deviceReplacement)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeUser)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.other)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.ChangeNumber)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.EnableHotspot)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.SuspendResumeService)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simActivation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeVendor)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.pukCode)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherSIMReplacement)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherChangeOfPlan);

        return (
            <>
                <NotificationModal
                    show={this.state.showNotif}
                    title={'Success'}
                    message={`Plan details ${this.state.notifTitle} successfully!`}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />

                <CustomDropdown activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} label={sectionTitle}>
                    <div className="add-plan-container">
                        {this.props.isInventoryCircuit ?
                            <CustomSearchableDropdownWrapper
                                label={this.toLocaleLanguage("plan_name_capital")}
                                options={circuitPlans}
                                selected={inventoryCicuitPlanDetailsForm.UniquePlanIdentifier}
                                fieldProp='inventoryCicuitPlanDetailsForm.UniquePlanIdentifier'
                                onChange={(e) => this.searchableChange(e, "inventoryCicuitPlanDetailsForm.UniquePlanIdentifier")}
                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                tagName='PlanName'
                                optionLabelKey={{
                                    Key: 'UniquePlanIdentifier',
                                    Value: 'PlanNameOrderable',
                                    Label: 'PlanNameOrderable',
                                }}
                                disabled={isDisable}
                                maxLength={MAX_LENGTH.limit_255}
                                requiredField={isRequestRequired}
                                isOriginalPlan={this.state.isOrigComponent}
                                onSearchChange={this.handleCircuitPlansSearch}
                                onLoadMore={this.loadMoreCircuitPlans}
                                isLoading={isCircuitPlansLoading}
                                hasMore={hasMoreCircuitPlans}
                            />
                            :
                            <CustomSearchableDropdownWrapper
                                label={this.toLocaleLanguage("plan_name_capital")}
                                options={circuitPlans}
                                selected={inventoryCicuitPlanDetailsForm.PlanId}
                                fieldProp='inventoryCicuitPlanDetailsForm.PlanId'
                                onChange={(e) => this.searchableChange(e, "inventoryCicuitPlanDetailsForm.PlanId")}
                                placeholder={isDisable ? '' : `${this.toLocaleLanguage('select_placeholder')}`}
                                tagName='PlanName'
                                optionLabelKey={{
                                    Key: 'PlanId',
                                    Value: 'PlanNameOrderable',
                                    Label: 'PlanNameOrderable',
                                }}
                                disabled={isDisable}
                                maxLength={MAX_LENGTH.limit_255}
                                requiredField={isRequestRequired}
                                onSearchChange={this.handleCircuitPlansSearch}
                                onLoadMore={this.loadMoreCircuitPlans}
                                isLoading={isCircuitPlansLoading}
                                hasMore={hasMoreCircuitPlans}
                            />
                        }
                        {!isLoadingComponents && (!inventoryCicuitPlanDetailsForm.PlanId || planComponents[0]?.dataItem?.length > 0 && this.state.isOrigComponent) &&
                            <>
                                <TablePagination
                                    columns={planComponents[0]?.HeaderItem}
                                    pageList={planComponents[0]?.dataItem}
                                    haveExternalDeleteBtn={this.props.haveEditRemoveBtn}
                                    isNotSortable={true}
                                    paginationHidden={true}
                                />
                            </>
                        }
                        {!isLoadingComponents && (!inventoryCicuitPlanDetailsForm.PlanId || planComponents[0]?.dataItem?.length > 0 && !this.state.isOrigComponent) &&
                            <>
                                <TableWithButton
                                    classNameWrapper="detail-list-modal"
                                    datatable={planComponents}
                                    haveExternalDeleteBtn={false}
                                    hasColumnCheckbox={true}
                                    enableCheckBox={true}
                                    onPlanComponentCheck={this.handleCheckItem} // Handle individual checkbox changes
                                    onSelectAllChange={this.handleSelectAllChange} // Handle "Select All" checkbox
                                    checkedItems={this.state.checkedItems} // Pass current checked items
                                    allItems={this.props.planComponents} // Pass all items for "Select All"
                                    isInventoryCircuit={this.props.isInventoryCircuit}
                                    updatedCheckboxState={this.state.updatedCheckboxState}
                                    noData={true}
                                    handleCloseNotif={this.handleCloseNotif}
                                />
                            </>
                        }
                        {!this.displayActionButtons() && !noAddFunction &&
                            <div className="add-button-container custom-add-button mb-3">
                                <div className="btn-tooltiptext">
                                    <Button onClick={this.cancelBtn.bind(this)} className="btn-custom-violet-hover-outline">Cancel</Button>
                                    <span className="tooltip-text">{this.toLocaleLanguage('cancel_plan_details')}</span>
                                </div>


                                <ConfirmationNotificationModal
                                    show={this.state.showModal}
                                    message={`Are you sure you want to ${this.state.isUpdate ? `${ACTION_TYPES.Update.toLowerCase()}` : `${ACTION_TYPES.Add.toLowerCase()}`}?`}
                                    title={this.state.notifTitle}
                                    handleModal={this.handleConfirmationModal}
                                    className={'comment-notification-modal'}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />
                                <div className={'btn-tooltiptext'}>
                                    <Button
                                        className="btn-add"
                                        disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) || completed ? true : hasPendingApproval ? hasPendingApproval :
                                            (isUpdate ? this.isUpdateBtnDisable(this.state, inventoryCicuitPlanDetailsForm, circuitPlans) : !enableButton)}
                                        onClick={planDetails?.datatable[0]?.dataItem?.length === 0 ? this.onClickAdd : this.onClickUpdate}>{planDetails?.datatable[0]?.dataItem?.length === 0 ? `${ACTION_TYPES.Add}` : `${ACTION_TYPES.Update}`}
                                    </Button>
                                    <span className="tooltip-text">{planDetails?.datatable[0]?.dataItem?.length === 0 ? this.toLocaleLanguage('add_plan_details'): this.toLocaleLanguage('update_plan_details') }</span>
                                </div>
                            </div>}

                    </div>
                </CustomDropdown>
                {
                    hasExistingPlan &&
                    <div className="details-table-container add-sim-container">
                        <TableWithButton
                            classNameWrapper="table-details-wrapper table-clickable"
                            datatable={planDetails.datatable}
                            haveExternalDeleteBtn={this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite ? true : false))}
                            deleteAction={this.deletePlanDetails}
                            rowClickAction={this.onRowClickPlanDetails}
                            updateNotifTitle={this.updateNotifTitle}
                            handleOpenNotif={this.handleOpenNotif}
                            hideDeleteBtn={this.props.hideDeleteBtn}
                            handleCloseNotif={this.handleCloseNotif}
                        />
                    </div>
                }
            </>
        )
    }
};
export default connect(
    state => {
        const { inventoryCircuitPlanDetails, translation } = state;
        const { inventoryCicuitPlanDetailsForm } = state.form;
        return {
            inventoryCircuitPlanDetails
            , inventoryCicuitPlanDetailsForm
            , ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, addPlanDetailActions),
        dispatch
    )
)(AddPlanDetails);